import styled from 'styled-components';

export const WaveWrapper = styled.div`
  color: var(--color-fixed-tint);
  svg {
    width: 100%;
    margin: 0 auto;
  }
`;
